import type { NUtils } from '@app/types';

export const adaptDataToSelect: NUtils.AdaptDataToSelect = (data) => {
  return data?.map(({ Id, Name }) => ({
    label: Name,
    value: Id,
  }));
};
